import { NgTemplateOutlet } from '@angular/common';
import { Component, input, TemplateRef, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { MatMenu } from '@angular/material/menu';
import { DataManagerController } from '../application/data-manager-controller';
import {
  DataManagerColuna,
  DataManagerColunaDadoAdicional,
  DataManagerColunaGrupo,
  DataManagerOrdenacaoSentido,
} from '../contracts/data-manager.model';
import { DataManagerGrupo } from '../state/data-manager-grupo';

@Component({
  selector: 'app-data-manager-menu',
  templateUrl: 'data-manager-menu.component.html',
  imports: [CdkMenu, CdkMenuItem, CdkMenuTrigger, FormsModule, MatCheckbox, MatIcon, MatMenu, NgTemplateOutlet],
})
export class DataManagerMenuComponent<T> {
  // Inputs
  dmController = input.required<DataManagerController<T>>();
  ocultarGrupo = input(false);
  ocultarSubtotal = input(false);

  // Exporta templates
  colunasMenu = viewChild.required<TemplateRef<unknown>>('colunasMenu');
  gruposMenu = viewChild.required<TemplateRef<unknown>>('gruposMenu');

  // Metodos protected
  protected agrupar(coluna: DataManagerColunaGrupo) {
    this.dmController().grupoAdicionar(coluna);
  }

  protected expandirRetrairGrupo(grupo: DataManagerGrupo<T>, expandir: boolean) {
    this.dmController().grupoExpandirRetrair(grupo, expandir);
  }

  onDadoAdicionalChanged(item: DataManagerColunaDadoAdicional) {
    this.dmController().dadoAdicionalSelecionado(item);
  }

  protected onToggleOcultarColuna(coluna: DataManagerColunaGrupo, ocultar: boolean) {
    this.dmController().toggleOcultarColuna(coluna, ocultar);
  }

  protected ordenar(coluna: DataManagerColuna, direcao?: DataManagerOrdenacaoSentido) {
    this.dmController().ordenar(coluna, direcao);
  }

  protected totalizar(coluna: DataManagerColunaGrupo) {
    this.dmController().totalizar(coluna);
  }

  protected removerGrupo(coluna: DataManagerColunaGrupo) {
    this.dmController().grupoRemover(coluna);
  }
}
